import { cn } from '@/lib/cn';
import type { Outcome } from '@/lib/bet';

/**
 * The outcome chip — one shared rendering so a bet reads identically in the
 * single-bet verdict and in a side-by-side comparison.
 */
export function OutcomeChip({ outcome }: { outcome: Outcome }) {
  const map: Record<Outcome, { label: string; cls: string }> = {
    won: { label: 'won', cls: 'border-ok/40 bg-ok-bg text-ok' },
    lost: { label: 'lost', cls: 'border-hairline-strong bg-surface-sunken text-text-dim' },
    'rolled-back': { label: 'rolled back', cls: 'border-warn/40 bg-warn-bg text-warn' },
    open: { label: 'round open', cls: 'border-info/40 bg-info-bg text-info' },
    unknown: { label: 'unknown', cls: 'border-hairline bg-surface-sunken text-text-faint' },
  };
  const m = map[outcome] ?? map.unknown;
  return (
    <span
      className={cn(
        'inline-block border px-1.5 py-0.5 font-condensed text-[10px] font-semibold uppercase tracking-wider',
        m.cls,
      )}
    >
      {m.label}
    </span>
  );
}
